export default Object.freeze({
  notYetUploaded: 'Not yet uploaded',
  pendingConfirmation: 'Pending confirmation',
  confirmed: 'Confirmed',
});
